<template>
  <div class="money-clear-log">
    <div class="filter-bar">
      <Select
        v-model="page.company_id"
        class="company-select"
        filterable
        remote
        clearable
        :loading="companyLoading"
        :remote-method="searchCompany"
        placeholder="选择企业"
      >
        <Option
          v-for="company in companyOptions"
          :key="company.id"
          :value="company.id"
        >{{ company.company_name || company.name }}</Option>
      </Select>
      <DatePicker
        v-model="dateRange"
        type="daterange"
        :editable="false"
        placeholder="选择清零日期范围"
        class="date-range"
        @on-change="dateChange"
      />
      <Button type="primary" icon="ios-search" @click="getData(1)">查询</Button>
      <Button icon="md-refresh" @click="reset">重置</Button>
    </div>

    <Table
      ref="table"
      :columns="columns"
      :data="log"
      :loading="tableLoading"
      size="small"
    />
    <div class="t-right">
      <Page
        :current="page.p + 1"
        :page-size="page.l"
        :total="total"
        show-elevator
        show-sizer
        show-total
        @on-change="pageChange"
        @on-page-size-change="sizeChange"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      page: {
        p: 0,
        l: 10,
        company_id: '',
        start: '',
        end: ''
      },
      dateRange: [],
      companyOptions: [],
      companyLoading: false,
      tableLoading: false,
      total: 0,
      log: [],
      columns: [
        { key: 'company_name', title: '企业名称', minWidth: 150 },
        {
          key: 'company_money',
          title: '企业清零前余额',
          minWidth: 130,
          render: (h, data) => h('span', this.formatMoney(data.row.company_money))
        },
        {
          key: 'staff_money',
          title: '员工余额合计',
          minWidth: 120,
          render: (h, data) => h('span', this.formatMoney(data.row.staff_money))
        },
        {
          key: 'staff_temp_quota',
          title: '临时配额合计',
          minWidth: 120,
          render: (h, data) => h('span', this.formatMoney(data.row.staff_temp_quota))
        },
        { key: 'staff_count', title: '涉及员工数', width: 100, align: 'center' },
        {
          key: 'create_time',
          title: '清零时间',
          minWidth: 160,
          render: (h, data) => h(
            'span',
            data.row.create_time
              ? this.$moment(data.row.create_time, 'YYYY-MM-DD HH:mm:ss')
              : '-'
          )
        },
        { key: 'operator_name', title: '操作人', minWidth: 110 },
        {
          key: 'reason',
          title: '清零原因',
          minWidth: 180,
          tooltip: true
        }
      ]
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    refreshTable () {
      this.$nextTick(() => {
        if (this.$refs.table && this.$refs.table.handleResize) {
          this.$refs.table.handleResize()
        }
      })
    },
    formatMoney (value) {
      let amount = Number(value)
      return isFinite(amount) ? amount.toFixed(2) : '0.00'
    },
    dateChange (dates) {
      this.page.start = dates[0] || ''
      this.page.end = dates[1] || ''
    },
    searchCompany (keyword) {
      if (!keyword || !keyword.trim()) {
        this.companyOptions = []
        return
      }
      this.companyLoading = true
      this.SearchCompany({ text: keyword.trim() }).then((res) => {
        this.companyOptions = Array.isArray(res) ? res : []
      }).catch(() => {
        this.companyOptions = []
      }).then(() => {
        this.companyLoading = false
      })
    },
    getData (filter) {
      if (filter) this.page.p = 0
      let params = {
        p: this.page.p,
        l: this.page.l
      }
      if (this.page.company_id) params.company_id = this.page.company_id
      if (this.page.start) params.start = this.page.start
      if (this.page.end) params.end = this.page.end

      this.tableLoading = true
      this.CompanyMoneyClearLog(params).then((res) => {
        if (!res || res.status !== true) {
          this.log = []
          this.total = 0
          this.$Message.error((res && res.msg) || '查询企业余额清零记录失败')
          return
        }
        this.log = Array.isArray(res.data) ? res.data : []
        this.total = Number(res.total) || 0
      }).catch((error) => {
        let response = error && error.response && error.response.data
        this.log = []
        this.total = 0
        this.$Message.error((response && response.msg) || '查询企业余额清零记录失败')
      }).then(() => {
        this.tableLoading = false
      })
    },
    reset () {
      this.page = {
        p: 0,
        l: 10,
        company_id: '',
        start: '',
        end: ''
      }
      this.dateRange = []
      this.companyOptions = []
      this.getData()
    },
    pageChange (page) {
      this.page.p = page - 1
      this.getData()
    },
    sizeChange (size) {
      this.page.l = size
      this.page.p = 0
      this.getData()
    },
    ...mapActions(['SearchCompany', 'CompanyMoneyClearLog'])
  }
}
</script>

<style lang="less" scoped>
.money-clear-log {
  .filter-bar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
  }
  .company-select {
    width: 240px;
  }
  .date-range {
    width: 240px;
  }
}
</style>
